import { fetchScripts } from './api';

const scriptLoads = new Map<string, Promise<void>>();
const formScriptLoads = new Map<string, Promise<void>>();

export const initializeExternalFormScripts = (formsUrl: string): Promise<void> => {
  if (!formScriptLoads.has(formsUrl)) {
    const loading = (async () => {
      const scripts = await fetchScripts(formsUrl);
      // Preserve the dependency order supplied by WordPress.
      for (const url of [...scripts.loadFirst, ...scripts.loadSecond]) {
        await registerScript(url);
      }
    })().catch((error) => {
      formScriptLoads.delete(formsUrl);
      throw error;
    });
    formScriptLoads.set(formsUrl, loading);
  }
  return formScriptLoads.get(formsUrl)!;
};

export const registerScript = (url: string): Promise<void> => {
  const source = new URL(url, document.baseURI).href;
  if (scriptLoads.has(source)) return scriptLoads.get(source)!;

  const loading = new Promise<void>((resolve, reject) => {
    const existing = Array.from(document.scripts).find((script) => script.src === source);
    // Scripts managed by this loader are always tracked by their shared promise.
    // Existing host-page scripts are owned by the host's loading lifecycle.
    if (existing) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = source;
    script.async = false;
    script.addEventListener('load', () => resolve(), { once: true });
    script.addEventListener('error', () => {
      script.remove();
      reject(new Error(`Failed to load the script ${source}`));
    }, { once: true });
    document.head.appendChild(script);
  }).catch((error) => {
    scriptLoads.delete(source);
    throw error;
  });
  scriptLoads.set(source, loading);
  return loading;
};
